// Endpoints

export const EP_DASHBOARD_STATS = 'dashboard/insights'
export const EP_DASHBOARD_PERFORMANCES = 'dashboard/performances'
export const EP_DASHBOARD_PERFORMANCES_ACTIVE_INFLUENCERS = 'dashboard/performances/activeInfluencers'
export const EP_DASHBOARD_PERFORMANCES_CLICKS_COUNT = 'dashboard/performances/clicksCount'
export const EP_DASHBOARD_PERFORMANCES_BEST_SOCIAL_MEDIA = 'dashboard/performances/bestSocialMedia'

export const EP_PERIODICITY_STATS = 'periodicity/insights'
export const EP_PERIODICITY_PERFORMANCES = 'periodicity/performances'

export const EP_CONVERSIONS_STATS = 'conversions/insights'
export const EP_CONVERSIONS_PERFORMANCES = 'conversions/performances'
export const EP_CONVERSIONS_PERFORMANCES_INFLUENCERS = 'conversions/performances/influencers'
export const EP_CONVERSIONS_PERFORMANCES_SUBCATEGORIES = 'conversions/performances/subcategories'
export const EP_CONVERSIONS_PERFORMANCES_SOCIALMEDIA = 'conversions/performances/socialmedia'

export const EP_DEVICE_STATS = 'devices/insights'

export const EP_INFLUENCERS_PERFORMANCES = 'influencers/performances'
export const EP_INFLUENCERS_PERFORMANCES_ACTIVE_INFLUENCERS = 'influencers/performances/activeInfluencers'
export const EP_INFLUENCERS_PERFORMANCES_AVERAGE_CLICKS = 'influencers/performances/averageClicks'
export const EP_INFLUENCERS_PERFORMANCES_BEST_SOCIAL_MEDIA = 'influencers/performances/bestSocialMedia'

export const EP_INFLUENCERS_INSIGHTS = 'influencers/insights'

export const EP_INFLUENCERS_PERIOD_SALES = 'influencers/periodSales'

export const EP_PRODUCTS_STATS = 'products/insights'
export const EP_PRODUCTS_INSIGHTS_SELECTED = 'products/insights/selected'
export const EP_PRODUCTS_INSIGHTS_SOLD = 'products/insights/sold'

export const EP_PRODUCTS_PERFORMANCES = 'products/performances'

export const EP_LOCATION_STATS = 'location/insights'
export const EP_LOCATION_INSIGHTS_SALES = 'location/insights/sales'
export const EP_LOCATION_SALES_INFLUENCERS = 'location/sales/influencers'
export const EP_LOCATION_SALES_SOCIAL = 'location/sales/social'

export const EP_LOCATION_SALES = 'location/sales'

export const EP_SEND_CONTACT_US_EMAIL = '/apiv1/dashboardBrand/sendContactUsEmail'
